import CloseIcon from '@mui/icons-material/Close'
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import styled from 'styled-components'

import { MOBILE_WIDTH } from 'pared/constants/styles'

export const ChatButton = styled.button`
  background-color: rgb(59, 59, 59);
  color: #fff;
  border: none;
  font-family: Lexend-SemiBold;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px 10px 0 0;
  padding: 15px 25px;
  min-width: 120px;
  white-space: nowrap;
`

export const ChatButtonTitle = styled.div`
  margin-left: 8px;
  font-size: 16px;
  font-weight: 700;
`

export const ChatWindow = styled.div<{
  isOpen: boolean
  width?: string
  height?: string
  isExpanded?: boolean
}>`
  width: ${(props) => {
    if (props.isExpanded) return 'calc(100vw - 270px)'
    return props.width || '500px'
  }};
  height: ${(props) => {
    if (!props.isOpen) return '0px'
    if (props.isExpanded) return 'calc(100vh - 100px)'
    return props.height || '800px'
  }};
  background-color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  position: fixed;
  bottom: 0px;
  right: ${(props) => (props.isExpanded ? '10px' : '40px')};

  @media ${MOBILE_WIDTH} {
    width: 100vw !important;
    left: 0;
    right: 0 !important;
    border-radius: 0;
    max-width: 100vw;
    height: ${(props) => {
      if (!props.isOpen) return '0px'
      if (props.isExpanded) return 'calc(100vh - 40px)'
      return props.height || '85vh'
    }};
  }

  @media (max-height: 599px) and (orientation: landscape) {
    width: 90vw !important;
    left: 0;
    right: 5px !important;
    border-radius: 0;
    max-width: 90vw;
    height: ${(props) => {
      if (!props.isOpen) return '0px'
      if (props.isExpanded) return '50vw'
      return props.height || '40vw'
    }} !important;
    max-height: 50vw !important;
  }
`

export const ChatHeader = styled.div<{
  isOpen: boolean
  isExpanded?: boolean
}>`
  background-color: rgb(59, 59, 59);
  color: #fff;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 58px;
  z-index: 1;
  border-radius: 10px 10px 0 0;
`

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  font-family: Lexend-SemiBold;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
`

export const ChatIcon = styled.img`
  width: 30px;
  height: 30px;
  margin: 4px 8px 4px 2px;
`

export const StyledIconButton = styled(CloseIcon)`
  color: #fff;
  cursor: pointer;
`

export const StyledExpandIcon = styled(OpenInFullIcon)`
  color: #fff;
  cursor: pointer;
`

export const StyledShrinkIcon = styled(CloseFullscreenIcon)`
  color: #fff;
  cursor: pointer;
`

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ChatIframe = styled.iframe`
  width: 100%;
  height: calc(100% - 58px);
  border: none;
  overflow: auto;
  display: block;
  flex-shrink: 0;
  position: absolute;
  top: 58px;
  left: 0;
`

export const ChatButtonContainer = styled.div<{
  isOpen: boolean
}>`
  display: flex;
  opacity: ${(props) => (!props.isOpen ? 1 : 0)};
  justify-content: flex-end;
  position: fixed;
  bottom: 0px;
  right: 40px;
  z-index: 10000;
  pointer-events: ${(props) => (!props.isOpen ? 'auto' : 'none')};
  transition: opacity 0.2s ease-in-out;
  transition-delay: ${(props) => (!props.isOpen ? '0.2s' : '0s')};

  @media ${MOBILE_WIDTH} {
    right: 0;
  }

  @media (max-height: 599px) and (orientation: landscape) {
    right: 5px;
  }
`
